module.exports = __webpack_public_path__ + "static/media/vote.8db06df2.svg";